// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import Link from "next/link";
import ReactLoadingSkeleton from "react-loading-skeleton";
import * as ReactLoadingSkeleton$1 from "react-loading-skeleton";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as HomeVMMapper$PorterinFeature from "../view-model/HomeVMMapper.mjs";
import * as EnterpriseV2ModuleScss from "../styles/EnterpriseV2.module.scss";
import * as EnterpriseGrowthCardCmp$PorterinFeature from "./EnterpriseGrowthCardCmp.mjs";

var styles = EnterpriseV2ModuleScss;

import 'react-loading-skeleton/dist/skeleton.css'
;

function EnterpriseBannerCmp(Props) {
  var is_loadingOpt = Props.is_loading;
  var link = Props.link;
  var is_enterprise_v2_enabledOpt = Props.is_enterprise_v2_enabled;
  var page_data = Props.page_data;
  var is_loading = is_loadingOpt !== undefined ? is_loadingOpt : false;
  var is_enterprise_v2_enabled = is_enterprise_v2_enabledOpt !== undefined ? is_enterprise_v2_enabledOpt : false;
  return React.createElement(React.Fragment, undefined, is_loading ? React.createElement("div", {
                    className: styles["banner-wrapper"]
                  }, React.createElement(ReactLoadingSkeleton$1.SkeletonTheme, {
                        baseColor: "#e6e6e6",
                        highlightColor: "#FEFEFE",
                        duration: 2.0,
                        children: React.createElement(ReactLoadingSkeleton, {
                              height: "7.7rem",
                              borderRadius: "1.2rem",
                              containerClassName: styles["skeleton-1"]
                            })
                      })) : (
                is_enterprise_v2_enabled && page_data.enterprise_banner.text !== "" ? React.createElement("div", {
                        className: styles["banner-wrapper"]
                      }, React.createElement(Link, {
                            href: link,
                            children: null,
                            className: styles["banner-text-wrapper"]
                          }, React.createElement("h1", {
                                className: styles["banner-text"]
                              }, page_data.enterprise_banner.text), React.createElement("h1", {
                                className: styles["banner-subtext"]
                              }, page_data.enterprise_banner.sub_text), React.createElement("div", {
                                className: styles["arrow-icon"]
                              }, React.createElement(NextImage$PorterinFeature.make, {
                                    src: page_data.enterprise_banner.image.path,
                                    height: HomeVMMapper$PorterinFeature.arrow_icon.height,
                                    width: HomeVMMapper$PorterinFeature.arrow_icon.width,
                                    alt: HomeVMMapper$PorterinFeature.arrow_icon.alt
                                  })))) : React.createElement(EnterpriseGrowthCardCmp$PorterinFeature.make, {
                        section_data: page_data.enterprise_home_section
                      })
              ));
}

var Link$1;

var make = EnterpriseBannerCmp;

export {
  styles ,
  Link$1 as Link,
  make ,
}
/* styles Not a pure module */
